"use client";

import {
  MyComediansOrderBy,
  getMyComedians,
} from "@/data/v2/client/user/comedians";
import { useQuery } from "@tanstack/react-query";

export function useMyComedians({
  orderBy,
}: { orderBy?: MyComediansOrderBy } = {}) {
  return useQuery({
    queryKey: ["my-comedians", { orderBy }],
    queryFn: () => getMyComedians({ orderBy }),
    staleTime: 30_000,
  });
}
